import React from 'react'
import { isObject } from 'formik'

import * as El from '../styles'

/**
 * Takes 'aaa.bbb.ccc' string and returns
 * src[aaa][bbb][ccc] so its easier to work with Formik
 * @param {object} src - source object
 * @param {string} str - string of words connected with '.'
 */
export const reducer = (src, str) => {
  const array = str.split('.')
  return array.reduce(
    (p, _, i) =>
      p && p[array[i + 1]]
        ? p[array[i + 1]]
        : i + 1 === array.length ? p : false,
    src[array[0]]
  )
}

export const getError = (formik, name) => {
  const { errors, touched } = formik
  const error = reducer(errors, name)
  if (error && reducer(touched, name)) { return <El.ErrorText>{error}</El.ErrorText> }
}

export const flattenObject = ob => {
  let toReturn = {}

  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) continue

    if (typeof ob[i] === 'object') {
      let flatObject = flattenObject(ob[i])
      for (let x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue

        toReturn[i + '.' + x] = flatObject[x]
      }
    } else {
      toReturn[i] = ob[i]
    }
  }
  return toReturn
}

export const setObjectTouched = (object, setFieldTouched, name) => {
  Object.keys(object).forEach(key => {
    const elem = object[key]
    if (isObject(elem)) {
      setObjectTouched(elem, setFieldTouched, `${name}.${key}`)
    } else {
      setFieldTouched(`${name}.${key}`)
    }
  })
}
